import { render, staticRenderFns } from "./contactsNumberEdit.vue?vue&type=template&id=1cfdae01&scoped=true"
import script from "./contactsNumberEdit.vue?vue&type=script&lang=js"
export * from "./contactsNumberEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfdae01",
  null
  
)

export default component.exports